import { cn } from '@Utils/cn';

import FieldShell from './FieldShell';

export interface IconToggleOption {
  value: string;
  label: string;
  icon?: React.ReactNode;
}

interface IconToggleFieldProps {
  title?: string;
  description?: string;
  options: IconToggleOption[];
  value?: string;
  onChange: (value: string) => void;
}

/** Boxed icon buttons with a small label, one selected (e.g. orientation, alignment). */
export default function IconToggleField({
  title,
  description,
  options,
  value,
  onChange,
}: IconToggleFieldProps) {
  return (
    <FieldShell title={title} description={description}>
      <div className="flex gap-2">
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            aria-label={option.label}
            onClick={() => onChange(option.value)}
            className={cn(
              'flex grow flex-col items-center gap-1.5 rounded-lg border border-gray-200 px-2 py-3 text-zinc-700 hover:bg-zinc-50',
              value === option.value &&
                'border-[#CAAE6F] bg-[#F4F0E4] hover:bg-[#EAE0C8]',
            )}
          >
            {option.icon}
            <span className="text-xs">{option.label}</span>
          </button>
        ))}
      </div>
    </FieldShell>
  );
}
